<script setup lang="ts">
import { variantTextColorClassKey } from "./Alert.vue"

const variantTextColorClass = inject(variantTextColorClassKey)
</script>

<template>
  <TypographyText :class="variantTextColorClass"><slot /></TypographyText>
</template>
